import BANKS from '@sdk/helpers/domains/banks';

const BRADESCO = BANKS.BRADESCO.code;
const BV = BANKS.BV.code;
const CREDITAS = BANKS.CREDITAS.code;
const C6 = BANKS.C6.code;
const FONTECRED = BANKS.FONTECRED.code;
const HONDA = BANKS.HONDA.code;
const ITAU = BANKS.ITAU.code;
const PAN = BANKS.PAN.code;
const SANTANDER = BANKS.SANTANDER.code;
const KUNA = BANKS.KUNA.code;
const MONEYPLUS = BANKS.MONEYPLUS.code;
const SAFRA = BANKS.SAFRA.code;

export default {
  cpf: [BRADESCO, BV, CREDITAS, FONTECRED, HONDA, ITAU, PAN, SANTANDER, KUNA, MONEYPLUS, SAFRA],
  name: [BRADESCO, BV, C6, CREDITAS, FONTECRED, HONDA, ITAU, PAN, SANTANDER, KUNA, MONEYPLUS, SAFRA],
  nickname: [],
  born_at: [BRADESCO, BV, CREDITAS, FONTECRED, HONDA, ITAU, PAN, SANTANDER, KUNA, MONEYPLUS, SAFRA],
  genre_id: [BRADESCO, BV, CREDITAS, FONTECRED, HONDA, ITAU, PAN, SANTANDER, KUNA, MONEYPLUS],
  education_id: [FONTECRED, HONDA],
  nationality: [BRADESCO, BV, FONTECRED, HONDA, PAN, SANTANDER, SAFRA],
  state_of_birth_id: [BV, FONTECRED, HONDA, PAN, SANTANDER],
  place_of_birth: [BV, FONTECRED, HONDA, PAN, SANTANDER],
  property: [BV, C6, CREDITAS, HONDA],
  public_person: [HONDA, PAN],
  mother: [BRADESCO, C6, BV, FONTECRED, HONDA, ITAU, PAN, SANTANDER, SAFRA],
  father: [HONDA],
  have_credit_card: [],
  credit_cards: [],
  accept_boleto: [HONDA],
  note: [],

  document_type: [BRADESCO, BV, C6, CREDITAS, HONDA, PAN, SANTANDER],
  rg: [BRADESCO, BV, C6, CREDITAS, FONTECRED, HONDA, PAN, SANTANDER],
  rg_date: [BV, CREDITAS, C6, FONTECRED, HONDA, SANTANDER],
  rg_state_id: [BRADESCO, C6, BV, CREDITAS, FONTECRED, HONDA, PAN, SANTANDER],
  rg_issuing: [BRADESCO, BV, CREDITAS, FONTECRED, HONDA, PAN, SANTANDER],

  has_cnh: [HONDA, BV],
  cnh: [],
  cnh_type_id: [],

  marital_status_id: [
    BRADESCO,
    BV,
    C6,
    CREDITAS,
    FONTECRED,
    HONDA,
    ITAU,
    PAN,
    SANTANDER,
    KUNA,
    MONEYPLUS,
    SAFRA,
  ],
  spouse_name: [BV, CREDITAS, FONTECRED, HONDA, ITAU, PAN, SANTANDER],
  spouse_born_at: [BV, FONTECRED, HONDA, ITAU, PAN],
  spouse_cpf: [BV, CREDITAS, FONTECRED, HONDA, ITAU, PAN, SANTANDER, KUNA, MONEYPLUS],
  spouse_income_cents: [],

  have_bank_account: [BRADESCO, HONDA],
  bank_references: [{
    bank_id: [BRADESCO, HONDA],
    overdraft: [BRADESCO, HONDA],
    agency: [BRADESCO, HONDA],
    account_number: [BRADESCO, HONDA],
    digit: [BRADESCO, HONDA],
    open_at: [BRADESCO, HONDA],
  }],

  has_made_funding: [HONDA],
  previous_funding_bank_id: [HONDA],

  emails: [{
    address: [CREDITAS, C6, FONTECRED, HONDA, ITAU, KUNA, MONEYPLUS, PAN, SAFRA, SANTANDER],
  }],

  phones: [{
    code: [BRADESCO, BV, CREDITAS, FONTECRED, HONDA, ITAU, PAN, SANTANDER, KUNA, MONEYPLUS, SAFRA],
    number: [BRADESCO, BV, CREDITAS, FONTECRED, HONDA, ITAU, PAN, SANTANDER, KUNA, MONEYPLUS, SAFRA],
  }, {
    code: [BRADESCO, FONTECRED, HONDA, PAN, KUNA, MONEYPLUS],
    number: [BRADESCO, FONTECRED, HONDA, PAN, KUNA, MONEYPLUS],
  }],

  address: {
    zip_code: [
      BRADESCO,
      BV,
      C6,
      CREDITAS,
      FONTECRED,
      HONDA,
      ITAU,
      PAN,
      SANTANDER,
      MONEYPLUS,
      SAFRA,
    ],
    street: [BRADESCO, BV, CREDITAS, FONTECRED, HONDA, ITAU, PAN, SANTANDER, KUNA, MONEYPLUS, SAFRA],
    number: [BRADESCO, BV, C6, CREDITAS, FONTECRED, HONDA, ITAU, PAN, SANTANDER, KUNA, MONEYPLUS, SAFRA],
    complement: [BRADESCO, BV, CREDITAS, FONTECRED, HONDA, ITAU, PAN, SANTANDER, KUNA, MONEYPLUS, SAFRA],
    neighborhood: [
      BRADESCO,
      BV,
      CREDITAS,
      FONTECRED,
      HONDA,
      ITAU,
      PAN,
      SANTANDER,
      KUNA,
      MONEYPLUS,
      SAFRA,
    ],
    city: [BRADESCO, BV, CREDITAS, FONTECRED, HONDA, ITAU, PAN, SANTANDER, KUNA, MONEYPLUS, SAFRA],
    state_id: [BRADESCO, BV, CREDITAS, FONTECRED, HONDA, ITAU, PAN, SANTANDER, KUNA, MONEYPLUS, SAFRA],
    build_type_id: [
      BRADESCO,
      BV,
      CREDITAS,
      FONTECRED,
      HONDA,
      ITAU,
      PAN,
      SANTANDER,
      KUNA,
      MONEYPLUS,
      SAFRA,
    ],
    set_time_year: [BRADESCO, HONDA],
    set_time_month: [BRADESCO, HONDA],
    rent_value_cents: [BRADESCO, BV, CREDITAS, FONTECRED, HONDA, ITAU, PAN, SANTANDER, KUNA, MONEYPLUS],
  },

  addresses: [{
    INTERNAL_present: [HONDA],
  }, {
    INTERNAL_present: [HONDA],
  }],

  personal_references: [{
    name: [BRADESCO, HONDA],
    relationship: [HONDA],
    city: [HONDA],
    phone: [BRADESCO, HONDA],
    // phone: {
    //   code: [BRADESCO],
    //   number: [BRADESCO],
    // },
  }],

  job_reference: {
    name: [BRADESCO, BV, FONTECRED, HONDA, ITAU, PAN, KUNA, MONEYPLUS],
    cnpj: [BRADESCO, BV, FONTECRED, HONDA, ITAU, PAN],
    joined_at: [BRADESCO, BV, FONTECRED, HONDA, ITAU],
    income_cents: [BRADESCO, BV, C6, CREDITAS, FONTECRED, HONDA, ITAU, PAN, SANTANDER, KUNA, MONEYPLUS],
    department: [PAN],
    professional_ocupation_id: [BRADESCO, BV, CREDITAS, FONTECRED, HONDA, ITAU, PAN, SAFRA],
    profession_id: [
      BRADESCO,
      BV,
      C6,
      CREDITAS,
      FONTECRED,
      HONDA,
      ITAU,
      PAN,
      SANTANDER,
      KUNA,
      MONEYPLUS,
      SAFRA,
    ],
    detail: [BV, HONDA],
    phone: [BRADESCO, ITAU, HONDA, PAN, KUNA, MONEYPLUS],
    job_file: [BRADESCO, BV, CREDITAS, C6, FONTECRED, HONDA, ITAU, PAN, SANTANDER, KUNA, MONEYPLUS],
    // phone: {
    //   code: [ITAU, PAN],
    //   number: [ITAU, PAN],
    // },
    // address: [BRADESCO, ITAU, PAN],
    address: {
      zip_code: [BRADESCO, HONDA, ITAU, PAN],
      street: [BRADESCO, HONDA, ITAU, PAN],
      number: [BRADESCO, HONDA, ITAU, PAN],
      complement: [BRADESCO, HONDA, ITAU, PAN],
      neighborhood: [BRADESCO, HONDA, ITAU, PAN],
      city: [BRADESCO, HONDA, ITAU, PAN],
      state_id: [BRADESCO, HONDA, ITAU, PAN],
    },
    company_activity_id: [HONDA],
    another_income_cents: [HONDA],
    another_income_type_id: [HONDA],

    first_job: [HONDA],
    previous_work: [HONDA],
    previous_work_start_at: [HONDA],
    previous_work_end_at: [HONDA],
    previous_job_phone: [HONDA],
    // previous_job_phone: {
    //   code: [HONDA],
    //   number: [HONDA],
    // },
  },

  accountant: {
    name: [HONDA],
    city: [HONDA],
    phone: [HONDA],
  },
};
